import { useQuery } from '@tanstack/react-query'

import buildUrl from 'utilities/buildUrl'

import { endpoints } from './endpoints'
import { TenantData } from './types'
import { httpClient } from 'config/axios'

export const getTenantByCode = async (code: string) => {
  const response = await httpClient.get<TenantData>(
    buildUrl({
      route: endpoints.byCode,
      params: { code },
    }),
  )

  return response.data
}

export const useGetTenantByCode = (code?: string) => {
  return useQuery({
    queryKey: ['get-tenant-by-code', code],
    queryFn: async () => {
      if (code) {
        return await getTenantByCode(code)
      }
    },
    enabled: !!code,
    refetchOnWindowFocus: false,
  })
}
